// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_owl_carousel_dist_owl_carousel_js-node_modules_owl_carousel_dist_assets_-ec4f23"], () => (__webpack_require__("./wp-content/themes/hannaszive/assets/index.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
